import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=024cac56&"
import script from "./Sensor.vue?vue&type=script&lang=js&"
export * from "./Sensor.vue?vue&type=script&lang=js&"
import style0 from "./Sensor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports